import { render, staticRenderFns } from "./BaseDivWithAgreement.vue?vue&type=template&id=c6f9d4d2&scoped=true&"
import script from "./BaseDivWithAgreement.vue?vue&type=script&lang=js&"
export * from "./BaseDivWithAgreement.vue?vue&type=script&lang=js&"
import style0 from "./BaseDivWithAgreement.vue?vue&type=style&index=0&id=c6f9d4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f9d4d2",
  null
  
)

export default component.exports